import { PropsWithChildren } from 'react';
import dynamic from 'next/dynamic';
import { isSupported } from 'firebase/messaging';
import { firebaseEnabled } from './firebase.config';
import { devLog } from '@/utils/dev';

const FirebaseContainer = dynamic(
  async () => {
    const firebaseSupported = await isSupported();

    devLog('Firebase@Status', { firebaseEnabled, firebaseSupported });

    // * While isSupported isn't return true, We shouldn't import FirebaseContainer. Because it causes some problems.
    if (firebaseEnabled && firebaseSupported) {
      return import('./FirebaseContainer');
    }

    return Promise.resolve((props: PropsWithChildren) => {
      return <>{props?.children}</>;
    });
  },
  { ssr: false }
);

export default FirebaseContainer;
